// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@bg/App/Store/Reducers";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export const getQuickViewProductState = (state: CustomAppState) => {
    return state.quickView;
};

export function getSelectedImage(state: CustomAppState, product: ProductModel | undefined) {
    const { selectedImage } = state.quickView;
    if (!product || !product.images || product.images.length <= selectedImage) {
        return;
    }

    return product.images[selectedImage];
}
